module.exports = __webpack_public_path__ + "static/img/38.8f1726b9.gif";